import { mainTheme } from '@plecto/ui';
import styled from 'styled-components';

export const PaneButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 20px;
  gap: 12px;
`;

export const PaneContent = styled.div`
  padding: 0 20px 20px;
  color: ${mainTheme.text.primary};
  font-size: 14px;
`;
